import useOnScreen from '@hooks/useOnScreen';
import { getGuid } from '@services/utils/HelperFunctions';
import { theme } from '@styles/theme';
import { FC, useEffect, useRef, useState } from 'react';
import { PlacesType, Tooltip } from 'react-tooltip';
import styled from 'styled-components';

type TooltipProps = {
  trigger: JSX.Element;
  content: JSX.Element;
  cssClass?: string;
  position?: PlacesType;
  type?: 'light' | 'dark';
  onStateChange?: (value: boolean) => void;
};

const SharedTooltip: FC<TooltipProps> = ({
  trigger,
  content,
  cssClass,
  onStateChange,
  position,
  type = 'dark',
}) => {
  const ref = useRef<HTMLSpanElement>(null);
  const isVisible = useOnScreen(ref);
  const [id, setId] = useState<string>('');

  const afterShow = () => {
    if (onStateChange) {
      onStateChange(true);
    }
  };
  const afterHide = () => {
    if (onStateChange) {
      onStateChange(false);
    }
  };

  useEffect(() => {
    setId(getGuid());
  }, []);

  return (
    <>
      <span data-tooltip-id={id} ref={ref}>
        {trigger}
      </span>
      {content && isVisible && (
        <StyledTooltip
          positionStrategy='fixed'
          afterShow={afterShow}
          afterHide={afterHide}
          place={position || 'top'}
          className={`${cssClass || ''}`}
          id={id}
          variant={type}
          delayShow={300}
          delayHide={300}
        >
          <TooltipContent>{content}</TooltipContent>
        </StyledTooltip>
      )}
    </>
  );
};

export default SharedTooltip;

const StyledTooltip = styled(Tooltip)`
  line-height: ${theme.typography.h5}px;
  border-radius: 4px;
  background-color: ${theme.palette.darkBlue};
  color: ${theme.palette.white};
  opacity: 1 !important;
  text-align: center;
  z-index: 10000;

  max-width: 200px;
  height: auto !important;

  white-space: pre-line;
  overflow-wrap: break-word;
  word-wrap: break-word;
`;

const TooltipContent = styled.div`
  font-size: ${theme.typography.h6}px;
  font-family: ${theme.typography.fontFamily};
  font-style: ${theme.typography.normalFontStyle};
`;
